import Compound from '../models/Compound';

const COMPOUND_DEFINITIONS = [
  { id: 'H2O', formula: 'H₂O', plainFormula: 'H2O', name: 'Water', description: 'Two hydrogen atoms holding hands with one oxygen atom.' },
  { id: 'HCl', formula: 'HCl', plainFormula: 'HCl', name: 'Hydrochloric Acid', description: 'A strong acid. A weak version helps your stomach digest food.' },
];

export const COMPOUNDS = COMPOUND_DEFINITIONS.map((definition) => new Compound(definition));
